import React, { useState } from "react";
import { Volume2 } from "lucide-react";
import { StaffViewer } from "@/components/StaffViewer";
import { PianoKeyboard } from "@/components/PianoKeyboard";

const letter = (p) => p.slice(0, -1).replace("#", "♯").replace(/^([A-G])b$/, "$1♭");

// Chord symbols over the stave, with the selected chord lit up on the keyboard underneath.
export const ChordKeys = ({ chords, testId = "chord-keys" }) => {
  const [sel, setSel] = useState(0);
  const notes = chords.map((ch) => ({ pitches: ch.pitches, symbol: ch.symbol, label: "", duration: "half" }));
  const chord = chords[sel];
  return (
    <div className="mt-5 rounded-2xl border border-border bg-card p-4 sm:p-6" data-testid={testId}>
      <StaffViewer clef="treble" notes={notes} width={560} activeIndex={sel} testId={`${testId}-stave`}
        onNoteClick={(n) => setSel(notes.indexOf(n))} />
      <div className="mt-3 flex flex-wrap justify-center gap-2">
        {chords.map((ch, i) => (
          <button key={i} type="button" onClick={() => setSel(i)} data-testid={`${testId}-symbol-${i}`}
            className={`rounded-full border px-3 py-1 font-mono text-xs transition-colors ${i === sel ? "border-primary bg-primary/15 text-primary" : "border-border text-muted-foreground hover:border-primary/60"}`}>
            {ch.symbol}
          </button>
        ))}
      </div>
      <div className="mt-4" data-testid={`${testId}-keyboard`}>
        <PianoKeyboard start={3} octaves={3} highlight={Object.fromEntries(chord.pitches.map((p) => [p, ""]))} testId={`${testId}-kb`} />
      </div>
      <p className="mt-2 flex items-center justify-center gap-1.5 text-center text-xs font-bold text-foreground/80" data-testid={`${testId}-caption`}>
        <Volume2 size={12} /> {chord.symbol}: {chord.pitches.map(letter).join(" – ")}. Click a chord on the stave or a chord symbol to see it on the keyboard.
      </p>
    </div>
  );
};
